import { CroissantIcon } from "lucide-react";

export default function BrandHeader({ template }) {
  return (
    <header className="border-b border-stone-200 bg-white/80 backdrop-blur-sm sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="brand-logo">
          <img
            src="/brand/logo.jpg"
            alt="Baked By Ninis"
            className="h-11 w-auto object-contain"
          />
          <div className="hidden md:flex flex-col leading-tight border-l border-stone-200 pl-3 ml-1">
            <span className="font-heading font-semibold text-stone-900 text-sm tracking-tight">
              PO Toolkit
            </span>
            <span className="font-body text-[11px] uppercase tracking-widest text-stone-400">
              Ops Dashboard
            </span>
          </div>
        </div>
        <div className="hidden sm:block font-body text-sm text-stone-500">
          {template?.exists ? (
            <span data-testid="header-template-info">
              Template: <span className="text-stone-900 font-medium">{template.filename}</span>
            </span>
          ) : (
            <span className="text-amber-700">No template set</span>
          )}
        </div>
      </div>
    </header>
  );
}
